import { createStyles } from 'utils/css'

import { IMultiLineTextStyles } from './MultiLineText.types'

export const root = ({
  alignment,
  color,
  margin,
  size,
  styles
}: IMultiLineTextStyles) =>
  createStyles(({ alignments, colors, fontSizes, spacing, treatments }) => {
    const defaultStyles = {
      ...treatments.body,
      color: colors[color] || color,
      fontSize: fontSizes[size],
      fontWeight: 'inherit',
      textAlign: alignments[alignment],
      margin: margin && spacing(margin),
      'white-space': 'pre-line'
    }

    return { ...defaultStyles, ...styles }
  })
